class TrackingDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    window.openTrackingDrawer = () => {
      document.getElementById('TrackingDrawer').classList.add('active');
      document.getElementById('TrackingDrawerOverlay').classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    window.closeTrackingDrawer = () => {
      document.getElementById('TrackingDrawer').classList.remove('active');
      document.getElementById('TrackingDrawerOverlay').classList.remove('active');
      document.body.style.overflow = '';
    };
  }
}

customElements.define('tracking-drawer', TrackingDrawer); 